// extracted by mini-css-extract-plugin
export default {"goods":"Order_goods__2XZHi","total":"Order_total__ROHEc","header":"Order_header__clw+M"};